import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../externals/searchDataProxy';
import { errorItemSearchData, receiveItemSearchData, REQUEST_ITEM_SEARCH_DATA } from '../actions/searchDataActions';
import { UNABLE_TO_FETCH_ITEM_SEARCH_DATA } from '../../helpers/messageConstant';

export function* fetchItemSearchData({ data }) {
  try {
    const itemSearchData = yield call(api.fetchItemSearchData, data);
    yield put(receiveItemSearchData(itemSearchData));
  } catch (e) {
    yield put(errorItemSearchData(UNABLE_TO_FETCH_ITEM_SEARCH_DATA));
  }
}

export function* searchDataSaga() {
  yield takeLatest(REQUEST_ITEM_SEARCH_DATA, fetchItemSearchData);
}
